export var DELETE_ASSET = 'DELETE_ASSET';
